import axios from "axios";
const UNAUTHORIZED_REDIRECT_FLAG = "__layerdUnauthorizedHandling";
const PENDING_TOAST_KEY = "app:pending-toast";

const axiosInstance = axios.create({
  baseURL: "/api/user/v1",
  headers: {
    "Content-Type": "application/json",
  },
});

const handleUnauthorizedError = async (error) => {
  if (error?.response?.status !== 401) return;

  const apiMessage = error?.response?.data?.message || error?.message || "Unauthorized";
  const toastPayload = {
    severity: "error",
    title: "Unauthorized",
    message: apiMessage,
  };

  try {
    window.sessionStorage.setItem(PENDING_TOAST_KEY, JSON.stringify(toastPayload));
  } catch (err) {
    // Ignore storage errors (private mode/quota/etc.)
  }

  window.dispatchEvent(
    new CustomEvent("app:toast", {
      detail: toastPayload,
    })
  );


  // Relax match: MCP paths may be fully-qualified ("/api/user/v1/mcp/...")
  // OR relative to the axios baseURL ("mcp/sites/..."). Normalise both.
  const _url = (error?.config?.url || "").replace(/^\/+/, "");
  if (_url === "mcp" || _url.startsWith("mcp/") || _url.startsWith("api/user/v1/mcp/")) {
    return;
  }

  if (!window[UNAUTHORIZED_REDIRECT_FLAG]) {
    window[UNAUTHORIZED_REDIRECT_FLAG] = true;
    try {
      if (typeof window.__layerdSignOut === "function") {
        await window.__layerdSignOut({
          returnTo: window?.location?.origin + "/v2/overview",
          federated: false,
        });
      } else {
        window.location.assign("/v2/overview");
      }
    } catch (err) {
      window.location.assign("/v2/overview");
    } finally {
      window[UNAUTHORIZED_REDIRECT_FLAG] = false;
    }
  }
};

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    if ("canceled" === error.message) {
      // This is not an error, but caused by Abort controller.
      return Promise.reject(error);
    }
    await handleUnauthorizedError(error);
    return Promise.reject((error.response && error.response.data) || "Something went wrong");
  }
);

export default axiosInstance;
